<template>
    <div>
        Test
    </div>
</template>
<script>

    import { mapActions } from 'vuex';

    export default {
        name: 'LogByUser',
        props: ['id', 'hash'],
        mounted() {
            this.logIn();
        },
        methods: {
            ...mapActions({
                logWithUserAction: 'auth/logWithUser'
            }),

            async logIn() {
                try {
                    let response = await this.logWithUserAction({
                        id: this.id,
                        hash: this.hash
                    });

                    this.$router.push({name: 'my-cars'});
                }
                catch(e) {
                    this.$router.push({name: 'homepage'});
                }
            }
        }
    }
</script>
